import { createSlice } from "@reduxjs/toolkit";

export const sendSmsSlice = createSlice({
  name: "send-sms",
  initialState: {
    isPostLoading: false,

    data: [],

    message: "",
  },
  reducers: {
    onPostSendSmsSubmit: (state) => {
      return {
        ...state,
        isPostLoading: true,

        postData: [],
        message: "",
      };
    },

    onPostSendSmsSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isPostLoading: false,

        postData: data,
        message,
        status_code,
      };
    },

    onPostSendSmsError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        postData: data,
        message,
        status_code,
        isPostLoading: false,
      };
    },
    onPostSendSmsReset: (state) => {
      return {
        ...state,
        isPostLoading: false,
        code: null,
        postData: [],
        message: "",
        status_code: null,
      };
    },
    onAllSmsSentSuccess: (state) => {
      return {
        code: 200,
      };
    },
  },
});
export const {
  onPostSendSmsSubmit,
  onPostSendSmsSuccess,
  onPostSendSmsError,
  onPostSendSmsReset,
  onAllSmsSentSuccess,
} = sendSmsSlice.actions;

export default sendSmsSlice.reducer;
